import React, { useEffect, createElement } from 'react';
import { TopBanner } from './components/TopBanner';
import { HeroSection } from './components/HeroSection';
import { IdentificationSection } from './components/IdentificationSection';
import { ProblemSection } from './components/ProblemSection';
import { MechanismSection } from './components/MechanismSection';
import { WhatYouGetSection } from './components/WhatYouGetSection';
import { WhoIsItForSection } from './components/WhoIsItForSection';
import { ProofSection } from './components/ProofSection';
import { FounderSection } from './components/FounderSection';
import { FAQSection } from './components/FAQSection';
import { BonusesSection } from './components/BonusesSection';
import { StackSection } from './components/StackSection';
import { FinalOfferSection } from './components/FinalOfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Footer } from './components/Footer';
import { initMetaPixel } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    document.title = 'Adiós Hinchazón: 3-Day Reset — Deshincha tu abdomen en 3 días';
    const setMeta = (property: string, content: string) => {
      let tag = document.querySelector(`meta[property="${property}"]`) as HTMLMetaElement;
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute('property', property);
        document.head.appendChild(tag);
      }
      tag.content = content;
    };
    setMeta('og:title', 'Adiós Hinchazón: 3-Day Reset');
    setMeta('og:description', 'Un plan simple de 3 días para ayudar a mujeres ocupadas a deshinchar abdomen y cuerpo, reducir la retención de líquidos y sentirse más ligeras sin dietas extremas.');
    setMeta('og:image', 'https://cdn.magicpatterns.com/uploads/obmiXzA8Rtge2bMWcaqEoG/adios_inchazon_3_Day_Reset.png');
    setMeta('og:type', 'website');
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-cream font-sans text-gray-900 selection:bg-gold selection:text-forest" data-id="element-0">
      <TopBanner data-id="element-1" />
      <HeroSection data-id="element-2" />
      <IdentificationSection data-id="element-3" />
      <ProblemSection data-id="element-4" />
      <MechanismSection data-id="element-5" />

      <WhatYouGetSection data-id="element-6" />
      <ProofSection data-id="element-7" />
      <WhoIsItForSection data-id="element-8" />
      <FounderSection data-id="element-9" />
      <BonusesSection data-id="element-10" />
      <StackSection data-id="element-11" />
      <FAQSection data-id="element-12" />
      <GuaranteeSection data-id="element-13" />
      <FinalOfferSection data-id="element-14" />
      <Footer data-id="element-15" />
    </div>;
}